module.exports = __webpack_public_path__ + "img/avatar-2.05c3657a.png";